import MentoringProcess from './MentoringProcess.vue';

export * from './types';
export default MentoringProcess;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/process/index.ts